import { SearchOutlined, Settings } from "@mui/icons-material"
import { InputAdornment, TextField } from "@mui/material"
import { useState } from "react";
import { Button } from "react-bootstrap";
import Select, { components } from "react-select";

const ValueContainer = ({ children, ...props }) => {
    let [values, input] = children;
    console.log("values: ", values.length)
    if (Array.isArray(values)) {
        const plural = values.length === 1 ? "" : "s";
        values = `${values.length} item${plural} selected`;
    }

    return (
        <components.ValueContainer {...props}>
            {values}
            {input}
        </components.ValueContainer>
    );
};

export const MessageTemplate = () => {
    const [selectedCategory, setSelectedCategory] = useState([])
    const [selectedLanguage, setSelectedLanguage] = useState([])
    const category = [
        { value: 'account update', label: 'Account update' },
        { value: 'appointment update', label: 'Appointment Update' },
        { value: 'issue resoulation', label: 'Issue Resoulation' },
        { value: 'shipping update', label: 'Shipping Update' },
        { value: 'ticket update', label: 'Ticket Update' }
    ]

    const language = [
        {value:'English Us', label:'English (US)'},
        {value:'Indonesian', label:'Indonesian'},
        {value:'Portuguese', label:'Portuguese (BR)'},
        {value:'Spanish', label:'Spanish'},
    ]


    return (
        <>

            <div style={{ margin: "20px", backgroundImage: `linear-gradient(to right, "#edf9f8", "#e9e2f8` }}>
                <h5><strong>Message Templates</strong></h5>

                <div style={{ marginTop: "40px", height: "65px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", boxShadow:' rgb(0 0 0 / 25%) 1px 1px 6px' }} className="card text-bg-black">
                    <TextField
                        style={{ flex: "1", marginLeft: "10px", marginRight: "10px" }}
                        size="small"
                        id="standard-bare"
                        variant="outlined"
                        placeholder="Search..."
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" style={{ padding: "0px", margin: "0px" }}>
                                    <SearchOutlined style={{ padding: "0px", margin: "0px" }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <div style={{ width: '14%', marginRight:'12px' }}>
                        <Select
                            value={selectedCategory}
                            onChange={(s) => setSelectedCategory(s)}
                            isMulti
                            placeholder='Category'
                            options={category}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                                ValueContainer
                            }} >

                        </Select>
                    </div>

                    <div style={{ width: '14%', marginRight:'12px' }}>
                        <Select
                            value={selectedLanguage}
                            onChange={(s) => setSelectedLanguage(s)}
                            isMulti
                            placeholder='Language'
                            options={language}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                                ValueContainer
                            }} >

                        </Select>
                    </div>

                    
                    <div style={{ width: '14%', marginRight:'12px' }}>
                        <Select
                            value={selectedLanguage}
                            onChange={(s) => setSelectedLanguage(s)}
                            isMulti
                            placeholder='Language'
                            options={language}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                                ValueContainer
                            }} >

                        </Select>
                    </div>

                    <div style={{ width: '14%', marginRight:'70px' }}>
                        <Select 
                            value={selectedLanguage}
                            onChange={(s) => setSelectedLanguage(s)}
                            isMulti
                            placeholder='Language'
                            options={language}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                                ValueContainer
                            }} >

                        </Select>
                    </div>

                    <Button  style={{backgroundColor:"#e4e7ef", color:'#444950', marginRight:"12px", fontSize:"12px"}}>
                        <Settings style={{width:"20px", height:"20px", color:"#444950", padding:"0px", margin:'0px'}}/><strong>Namespace</strong></Button>

                    <Button style={{color: '#fff', backgroundColor:'#0061a0', marginRight:"12px", fontSize:"12px"}}>Create template</Button>


                    {/* <CMultiSelect options={category} selectionType="counter" /> */}
                </div>

                <div style={{marginTop:'20px', boxShadow:' rgb(0 0 0 / 25%) 1px 1px 6px', borderRadius:'10px', padding:'12px'}}>Hello</div>

            </div>

        </>
    )

}